import React from "react";
import PublicNav from "@/components/landing/PublicNav";
import Hero from "@/components/landing/Hero";
import Stats from "@/components/landing/Stats";
import Features from "@/components/landing/Features";
import Pricing from "@/components/landing/Pricing";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import CTA from "@/components/landing/CTA";
import Footer from "@/components/landing/Footer";

export default function Landing() {
    return (
        <div className="relative min-h-screen bg-brand-void text-white overflow-hidden">
            <PublicNav />
            <Hero />
            <Stats />
            <Features />
            <Pricing />
            <Testimonials />
            <FAQ />
            <CTA />
            <Footer />
        </div>
    );
}
